import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuController} from '@ionic/angular';
import { EmailService } from '../../../../../app/common/services/email.service';
@Component({
  selector: 'app-test-email-sms',
  templateUrl: './test-email-sms.page.html',
   styleUrls: [
    './test-email-sms.page.scss'
  ]
})
export class TestEmailSMSComponent implements OnInit {
 inputValue: string = '';
 loaded:boolean;
 result:string;
 sendTo: string = '';

  constructor(
    public menu: MenuController,
    public emailService:EmailService
  ) { 
  
  }
  ngOnInit(): void {
      this.loaded=true;
  }


ionViewWillLeave() {
   this.menu.enable(false);
}

ionViewWillEnter() {
  this.menu.enable(false);
 
}
 async sendEmailTest() {
  this.loaded = false;

  // Check empty fields
  if (!this.sendTo) {
    alert('Please enter email address');
    this.loaded = true;
    return;
  }

  if (!this.inputValue) {
    alert('Please enter message');
    this.loaded = true;
    return;
  }

  // Email validation
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(this.sendTo)) {
    alert('Please enter a valid email address');
    this.loaded = true;
    return;
  }

  try {
    // Pass both email + message (recommended)
    this.result = await this.emailService.testEmail(this.sendTo, this.inputValue);
  } catch (error) {
    this.result = 'Error sending email';
    console.error(error);
  }

  this.loaded = true;
  console.log('Status:', this.result);
}

async sendSmsTest() {
  this.loaded = false;

  if (!this.sendTo) {
    alert('Please enter mobile number');
    this.loaded = true;
    return;
  }

  if (!this.inputValue) {
    alert('Please enter message');
    this.loaded = true;
    return;
  }

  // Indian mobile validation
  // const phonePattern = /^(\+91)?[6-9]\d{9}$/;
  // if (!phonePattern.test(this.sendTo)) {
  //   alert('Please enter a valid mobile number');
  //   this.loaded = true;
  //   return;
  // }

  try {
    this.result = await this.emailService.testSms(this.sendTo, this.inputValue);
  } catch (error) {
    this.result = 'Error sending SMS';
    console.error(error);
  }

  this.loaded = true;
}
}
